module.exports = __webpack_public_path__ + "img/money-bag.c27091f8.svg";